export default "__VITE_ASSET__QFUuJHEa__"